export default "__VITE_ASSET__aebb283a__"